import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './instagram-fix.css'; // Fix para navegadores in-app
import App from './App';
import reportWebVitals from './reportWebVitals';
const styles = {
  div255440: {
    maxWidth: '100%',
    overflowX: 'hidden',
    boxSizing: 'border-box',
    maxHeight: '100%',
    height: '100%'
  }
};
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<div style={styles.div255440}>
    <App />
  </div>);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();